import React, { useContext, useEffect } from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';
import { DataLayerEventContext } from '../../../contexts/dataLayerEventContext';
import usePlayOnceGif from '../../../hooks/usePlayOnceGif';

const IMAGES = {
  buttonGlass: 'images/23ua-prl-s-comp-blue/button-glass.png',
  pack: 'images/23ua-prl-s-comp-blue/pack.gif',
  tobaccoLeaf: 'images/23ua-prl-s-comp-blue/tobacco-leaf.png',
  filterAnimation: 'images/23ua-prl-s-comp-blue/filter.png',
  lensPackIcon: 'images/23ua-prl-s-comp-blue/lens-pack.png',
  surveyIcon: 'images/23ua-prl-s-comp-blue/survey.png'
};

const PROJECT_ID = 'Parliament soho compact blue new';

const BRAND_TITLE = 'Parliament SOHO';
const LINE_TITLE = 'Compact Blue';
const TAR = '6';
const NICOTINE = '0.5';

const SHOP_LINKS = {
  rozetka: 'https://rozetka.com.ua/ua/sigareti/c4638591/producer=parliament/',
  cigPoshta: 'https://cig-poshta.in.ua/shop/parliament/?utm_source=SP'
};

const ChevronIcon = () => (
  <svg
    className={styles.chevron}
    width="27"
    height="27"
    viewBox="0 0 27 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="13.5" cy="13.5" r="13" stroke="#FFFFFF" strokeOpacity="0.5" />
    <path
      d="M11.5 19L16.6464 13.8536C16.8417 13.6583 16.8417 13.3417 16.6464 13.1464L11.5 8"
      stroke="white"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
);

const GlassButton = ({ href, label }) => (
  <a
    className={styles.glassButton}
    href={href}
    target="_blank"
    rel="noopener noreferrer"
  >
    <img src={getImageFromS3(IMAGES.buttonGlass)} alt="" />
    <span>{label}</span>
  </a>
);

const PrlSCompBlueProductScreen = ({
  backgroundImage,
  handleToReview,
  handleToBrandLine,
  handleToAuthority,
  handleToRegistration
}) => {
  const { init, sendEvent } = useContext(DataLayerEventContext);
  const packSrc = usePlayOnceGif(getImageFromS3(IMAGES.pack));

  useEffect(() => {
    init(PROJECT_ID);
    sendEvent('seen_product_content');
  }, []);

  return (
    <div className={styles.container} style={{ backgroundImage }}>
      <div className={styles.hero}>
        <div className={styles.heroContent}>
          <p className={styles.brandTitle}>{BRAND_TITLE}</p>
          <p className={styles.lineTitle}>{LINE_TITLE}</p>
          <img className={styles.pack} src={packSrc} alt={LINE_TITLE} />
        </div>
      </div>

      <p className={styles.tagline}>
        Відтепер в <span>оновленому дизайні</span> з незмінним смаком
      </p>

      <div className={styles.reviewButton} onClick={handleToReview}>
        <p>Залишити відгук про продукт</p>
      </div>

      <div className={styles.contentSection}>
        <div className={styles.contentCard}>
          <span className={styles.contentDrop} />
          <div className={styles.characteristics}>
            <p>Вміст Смол • {TAR} мг</p>
            <p>Вміст Нікотину • {NICOTINE} мг</p>
          </div>
          <img
            className={styles.tobaccoLeaf}
            src={getImageFromS3(IMAGES.tobaccoLeaf)}
            alt="tobacco-leaf"
          />
        </div>
      </div>

      <div className={styles.filterSection}>
        <img
          className={styles.filterAnimation}
          src={getImageFromS3(IMAGES.filterAnimation)}
          alt="filter"
        />
        <div className={styles.filterList}>
          <span className={styles.filterLine} />
          <div className={styles.filterItem}>
            <span className={styles.filterDot} />
            <p>
              Ущільнена
              <br />
              повітряна камера
            </p>
          </div>
          <div className={styles.filterItem}>
            <span className={styles.filterDot} />
            <p>Вугільна частина</p>
          </div>
          <div className={styles.filterItem}>
            <span className={styles.filterDot} />
            <p>Ацетатна частина</p>
          </div>
        </div>
      </div>

      <div className={styles.fullRangeButton} onClick={handleToBrandLine}>
        <p>Повний асортимент</p>
      </div>

      <div className={styles.linkCard} onClick={handleToAuthority}>
        <img
          className={styles.lensPackIcon}
          src={getImageFromS3(IMAGES.lensPackIcon)}
          alt="lens-pack"
        />
        <p>
          Як <b>відрізнити оригінал</b> сигарет від підробки
        </p>
        <ChevronIcon />
      </div>

      <div className={styles.linkCard} onClick={handleToRegistration}>
        <img
          className={styles.surveyIcon}
          src={getImageFromS3(IMAGES.surveyIcon)}
          alt="survey"
        />
        <p>Пройти опитування</p>
        <ChevronIcon />
      </div>

      <div className={styles.buyBlock}>
        <p className={styles.buyBrandTitle}>{BRAND_TITLE}</p>
        <p className={styles.buyLineTitle}>{LINE_TITLE}</p>
        <p className={styles.buyDescription}>
          можна знайти на офіційних онлайн сервісах або у роздрібних точках
          продажу в твоєму місті
        </p>
        <div className={styles.buyButtons}>
          <GlassButton href={SHOP_LINKS.rozetka} label="rozetka" />
          <GlassButton href={SHOP_LINKS.cigPoshta} label="Cig-Poshta" />
        </div>
      </div>

      <div className={styles.hwFooter}>
        Куріння викликає серйозні захворювання та залежність Дана інформація про
        продукт надається відповідно до статті 15 Закону України «Про захист
        прав споживачів»
      </div>
    </div>
  );
};

export default PrlSCompBlueProductScreen;
